export default __webpack_public_path__ + "static/media/vip-exclusive.a195135f.svg";